module.exports = __webpack_public_path__ + "media/assets/images/flags/mg-c656e9a852d40a9a9317965b609d67a9.svg";